import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { StatusconfigurationService } from '../../business-services/status-configuration.service';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-status-configuration',
  templateUrl: './status-configuration.component.html',
})
export class StatusConfigurationComponent implements OnInit {

  statusList: any[] = []
  DMSstatusList: any[] = []
  tempstatus: any[] = []
  isRequired = false;
  mapData: { StatusId: number, DmsStatusId: number, DmsStatusLabel: string, LanguageId: number }[] = [];
  result: any;
  currentLanguage: number;
  currentLanguageCode: string;
  currentCulture: Subscription;
  userRoleRightsDetails: UserRoleMenu;
  constructor(
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
    private statusconfigurationService: StatusconfigurationService,
    private toasterService: ToastrService,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    private userService: UserDataService
  ) { }

  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.StatusConfiguration);
    this.currentCulture = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.currentLanguageCode = x;
      this.currentLanguage = Enums.LanguageCode[this.currentLanguageCode];
      this.GetStatusList();
    });
  }

  private GetStatusList() {
    this.spinner.show();
    this.statusconfigurationService.getStatusList(this.currentLanguage).then(result => {
      this.statusList = this.StatusDataMapper(result.statues);
      this.DMSstatusList = this.StatusDataMapper(result.dmS_Statues);
      this.result = result;
      this.MapStatuses(result.mapData);
      this.UpdateList(result.dmS_Statues);
      this.mapData = this.mapData.filter(x => x.LanguageId === this.currentLanguage);
      this.spinner.hide();
    }, _err => {
      this.spinner.hide();
    }
    );
  }

  private UpdateList(list: any[]) {
    this.tempstatus = [];
    this.statusList.forEach(_element => {
      this.tempstatus.push(this.StatusDataMapper(list));
    });
    this.mapData.forEach(element => {
      let data = element.StatusId - 1;
      for (let i = 0; i < this.tempstatus.length; i++) {
        if (data !== i) {
          const index = this.tempstatus[i].findIndex(x => x.Id === element.DmsStatusId && x.LanguageCode === this.currentLanguageCode);
          if (index !== -1) {
            (this.tempstatus[i] as []).splice(index, 1);
          }
        }
      }
    });
    this.checkStatus()
  }

  private MapStatuses(info: any[]) {
    this.statusList.forEach(status => {
      let obj = Object();
      obj.StatusId = status.id;
      let dmsStatusId = null;
      let dmsStatusLabel = null;
      info.forEach(element => {
        if (element.statusId === status.id) {
          dmsStatusId = element.dmsStatusId;
          dmsStatusLabel = this.DMSstatusList.find(x => x.id === element.dmsStatusId).dmsStatusLabel;
        }
      });
      obj.DmsStatusId = dmsStatusId;
      obj.DMSStatusLabel = dmsStatusLabel;
      obj.LanguageId = this.currentLanguage;
      this.mapData.push(obj);
    });
  }

  private StatusDataMapper(info: any) {
    let supperArray = [];
    if (info.length > 0) {
      info.forEach(element=>  {
        let status = Object();
        status.Id = element.Id;
        status.Name = element.Name;
        status.StepNo = element.StepNo;
        status.DMSStatusLabel = element.DMSStatusLabel;
        supperArray.push(element);
      })
    }
    return supperArray;
  }

  async saveStatus() {
    let data = [];
    this.mapData.forEach(element => {
      if (element.DmsStatusId != null) {
        data.push(element);
      }
    });

    let viewModel = {
      StatusMapDetails: data
    }
    this.spinner.show()
    let Successmsg = this.translate.instant("lblStatusMappedSuccess");
    let errormsg = this.translate.instant("lblStatusMappedError");
    (await this.statusconfigurationService.saveStatusConfiguration(viewModel)).subscribe(_result => {
      this.spinner.hide()
      this.toasterService.success(Successmsg);
    }, _err => {
      this.spinner.hide()
      this.toasterService.error(errormsg);
    }
    );
  }

  OnChange() {
    this.UpdateList(this.result.DMS_Statues);
  }

  checkStatus() {
    this.isRequired = false;
    const status = this.statusList.slice().sort((x, _y) => x.StepNo);
    const firstStep = status[0].Id;
    const lastStep = status[status.length - 1].Id;
    const data = this.mapData.filter(x => x.StatusId === firstStep || x.StatusId === lastStep);
    if (data.length >= 2 && data[0].DmsStatusId !== null && data[1].DmsStatusId !== null) {
      this.isRequired = true;
    }
  }

  ngOnDestroy(): void {
    if (this.currentCulture) {
      this.currentCulture.unsubscribe();
    }

  }
}
